import AnchorButtonContext from 'contexts/anchorButton'
import HTMLReactParser from 'html-react-parser'
import { useContext, useEffect, useState } from 'react'
import './categoryButtons.scss'

export default function CategoryButtons() {
   const { anchorButton } = useContext(AnchorButtonContext)
   const [midPart, setMidPart] = useState<number | null>(null)
   const [activeIndex, setActiveIndex] = useState<number | null>(0)

   useEffect(() => {
      if (anchorButton.length > 0) {
         setTimeout(() => {
            setActiveIndex(0)
         }, 200)
      }
   }, [])

   useEffect(() => {
      if (anchorButton.length > 4) {
         const halfLength = Math.floor(anchorButton.length / 2)
         setMidPart(halfLength)
      } else {
         setMidPart(anchorButton.length)
      }
   }, [anchorButton])

   useEffect(() => {
      const observer = new IntersectionObserver(
         (entries) => {
            entries.forEach((entry) => {
               if (entry.isIntersecting) {
                  const id = entry.target.getAttribute('id')
                  if (id && parseInt(id) >= 0 && parseInt(id) <= 8) {
                     setActiveIndex(parseInt(id, 10))
                  }
               }
            })
         },
         {
            root: null,
            threshold: 1,
            rootMargin: '40% 0px -40% 0px',
         },
      )
      const observerBefore = new IntersectionObserver(
         (entries) => {
            entries.forEach((entry) => {
               if (entry.isIntersecting) {
                  const id = entry.target.getAttribute('id')
                  if (id && parseInt(id) >= 0 && parseInt(id) <= 7) {
                     setActiveIndex(parseInt(id, 10) - 1)
                  }
               }
            })
         },
         {
            root: null,
            threshold: 1,
            rootMargin: '-60% 0px 60% 0px',
         },
      )

      const sections = document.querySelectorAll('div[id]')
      sections.forEach((section) => observer.observe(section))
      sections.forEach((section) => observerBefore.observe(section))

      // return () => {
      //    sections.forEach((section) => observer.unobserve(section))
      // }
   }, [anchorButton])

   const handleClick = (index: number) => {
      // setActiveIndex(index)
      document.getElementById(`${index}`)?.scrollIntoView({
         behavior: 'smooth',
      })
   }

   return (
      <>
         {anchorButton.length > 4 ? (
            <>
               <div className='flex center'>
                  {anchorButton.slice(0, midPart ?? 0).map((element: string, index: number) => (
                     <div
                        className={`categoryButtons flex center w100 ${
                           activeIndex === index ? 'active' : ''
                        }`}
                        key={index}
                        onClick={() => handleClick(index)}
                     >
                        <a href={window.location.href + '#' + index}>{HTMLReactParser(element)}</a>
                     </div>
                  ))}
               </div>
               <div className='flex center' id='toto'>
                  {anchorButton.slice(midPart ?? 0).map((element: string, index: number) => (
                     <div
                        className={`categoryButtons flex center w100 ${
                           activeIndex === index + (midPart !== null ? midPart : 0) ? 'active' : ''
                        }`}
                        key={index}
                        onClick={() => handleClick(index + (midPart !== null ? midPart : 0))}
                     >
                        <a
                           href={
                              window.location.href +
                              '#' +
                              ((midPart !== null ? midPart : 0) + index)
                           }
                        >
                           {HTMLReactParser(element)}
                        </a>
                     </div>
                  ))}
               </div>
            </>
         ) : (
            <div className='flex center'>
               {anchorButton.map((element: string, index: number) => (
                  <div
                     className={`categoryButtons flex center w100 ${
                        activeIndex === index ? 'active' : ''
                     }`}
                     key={index}
                     onClick={() => handleClick(index)}
                  >
                     <a href={window.location.href + '#' + index}>{HTMLReactParser(element)}</a>
                  </div>
               ))}
            </div>
         )}
      </>
   )
}
